import { Button } from "@/shared/ui";
import { useRouter } from "@tanstack/react-router";
import { startLogin } from "./session";

// Human sign-in is OIDC only (authentik); the API runs the flow and sends the
// browser back with a session cookie, or here with ?error=<code>.
const ERRORS: Record<string, string> = {
  no_user:
    "Your account is not set up in RTFM. Ask an admin to create a user with the email authentik has for you.",
  disabled: "Your RTFM account is disabled.",
  idp: "Sign-in was cancelled or refused by authentik.",
  failed: "Sign-in failed. Please try again.",
  unavailable: "Sign-in is not available right now (OIDC is not configured or unreachable).",
};

export function LoginPage() {
  const router = useRouter();
  const search = (router.state.location.search ?? {}) as { redirect?: string; error?: string };
  const error = search.error ? (ERRORS[search.error] ?? ERRORS.failed) : null;

  return (
    <main className="flex min-h-full items-center justify-center p-6">
      <div className="w-full max-w-sm rounded-lg border border-[var(--border)] bg-[var(--surface)] p-6 shadow-[var(--shadow-1)]">
        <h1 className="text-lg font-semibold">Sign in to RTFM</h1>
        <p className="mt-1 text-xs text-[var(--fg-muted)]">
          Sign in with your dkmaker account (authentik). Agents and tools use API keys instead.
        </p>
        {error && (
          <p role="alert" className="mt-4 text-xs text-[var(--danger)]">
            {error}
          </p>
        )}
        <Button
          type="button"
          className="mt-6 w-full"
          onClick={() => startLogin(search.redirect ?? "/")}
        >
          Continue with authentik
        </Button>
      </div>
    </main>
  );
}
